"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsSectionThumbnails = exports.ThumbnailSize = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var SearchIconButton_1 = require("./SearchIconButton");
var ThumbnailSize;
(function (ThumbnailSize) {
    ThumbnailSize["small"] = "small";
    ThumbnailSize["medium"] = "medium";
    ThumbnailSize["large"] = "large";
})(ThumbnailSize || (exports.ThumbnailSize = ThumbnailSize = {}));
var useSearchResultsSectionThumbnailsStyles = (0, react_jss_1.createUseStyles)({
    thumbnailWrapper: {
        display: "flex",
    },
});
var onIconClick = function (size, callback) {
    if (typeof callback === "function") {
        callback(size);
    }
};
var SearchResultsSectionThumbnails = function (props) {
    var onThumbnailSizeChange = props.onThumbnailSizeChange, selectedSize = props.selectedSize;
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.IThemeContext), 1), theme = _a[0];
    var classes = useSearchResultsSectionThumbnailsStyles();
    var iconSize = 22;
    var selectedColor = "primary";
    var unselectedColor = theme.colors.baseContrast040;
    return (React.createElement("div", { className: classes.thumbnailWrapper },
        React.createElement(SearchIconButton_1.SearchIconButton, { iconName: "gridLarge", iconSize: iconSize, onClick: function () { return onIconClick(ThumbnailSize.large, onThumbnailSizeChange); }, fill: selectedSize === ThumbnailSize.large ? selectedColor : unselectedColor }),
        React.createElement(SearchIconButton_1.SearchIconButton, { iconName: "gridMedium", iconSize: iconSize, onClick: function () { return onIconClick(ThumbnailSize.medium, onThumbnailSizeChange); }, fill: selectedSize === ThumbnailSize.medium ? selectedColor : unselectedColor }),
        React.createElement(SearchIconButton_1.SearchIconButton, { iconName: "gridSmall", iconSize: iconSize, onClick: function () { return onIconClick(ThumbnailSize.small, onThumbnailSizeChange); }, fill: selectedSize === ThumbnailSize.small ? selectedColor : unselectedColor })));
};
exports.SearchResultsSectionThumbnails = SearchResultsSectionThumbnails;
//# sourceMappingURL=SearchResultsSectionThumbnails.js.map